import * as React from 'react';
var PortalCompatContext = /*#__PURE__*/React.createContext( // eslint-disable-next-line @typescript-eslint/no-empty-function
function () {
  return function () {};
});
export var PortalCompatContextProvider = PortalCompatContext.Provider;
export function usePortalCompat() {
  return React.useContext(PortalCompatContext);
}
//# sourceMappingURL=PortalCompatContext.js.map